// extracted by mini-css-extract-plugin
module.exports = {"root":"DocList_root__11ZsM","attachment":"DocList_attachment__WqDgr"};